import {
  AutocompleteField,
  DateField,
  FormFieldAdapter,
} from "#src/components/form-builder/FormBuilderTemplates.ts";
import {
  SMOKING_FREQUENCIES,
  SMOKING_TYPES,
} from "#src/constants/smoking-usage.ts";
import { useSmokingUsage } from "#src/stores/insured-smoking-usage.ts";
import { mdiCalendar, mdiCalendarEnd, mdiSmoking } from "@mdi/js";
import { type Pinia } from "pinia";

function genTestId(storeName: string, testId: string) {
  return `${storeName}-${testId}`;
}

// NOTE(tim): drop the FormFieldAdapter at some point
interface AdditionalProps {
  mdColSize?: number;
  key: string;
  save: () => void;
}

export function useLastUseDateProperty(
  pinia: Pinia,
  module: string,
  additionalProps: Partial<AdditionalProps> = {}
) {
  return FormFieldAdapter(
    DateField({
      label: "When did you quit?",
      placeholder: "mm/dd/yyyy",
      dataTestid: genTestId(module, "last-use-date"),
      prependInnerIcon: mdiCalendarEnd,
      savableProperty: useSmokingUsage(module, pinia).last_use_date,
    }),
    {
      mdColSize: additionalProps?.mdColSize || 6,
      colSize: 12,
      key: additionalProps.key || "last_use_date",
    },
    additionalProps
  );
}

export function useCategoryProperty(
  pinia: Pinia,
  module: string,
  additionalProps: Partial<AdditionalProps> = {}
) {
  return FormFieldAdapter(
    AutocompleteField({
      dataTestid: genTestId(module, "category"),
      label: "What Type?",
      placeholder: "What Type?",
      prependInnerIcon: mdiSmoking,
      items: SMOKING_TYPES,
      savableProperty: useSmokingUsage(module, pinia).category,
    }),
    {
      mdColSize: additionalProps?.mdColSize || 6,
      colSize: 12,
      key: additionalProps.key || "category",
    },
    additionalProps
  );
}

export function useFrequencyProperty(
  pinia: Pinia,
  module: string,
  additionalProps: Partial<AdditionalProps> = {}
) {
  return FormFieldAdapter(
    AutocompleteField({
      dataTestid: genTestId(module, "frequency"),
      label: "How Often?",
      placeholder: "How Often?",
      prependInnerIcon: mdiCalendar,
      items: SMOKING_FREQUENCIES,
      savableProperty: useSmokingUsage(module, pinia).frequency,
    }),
    {
      mdColSize: additionalProps?.mdColSize || 6,
      colSize: 12,
      key: additionalProps.key || "frequency",
    },
    additionalProps
  );
}
